import * as Yup from 'yup'

export const RejectSchema = Yup.object().shape({
  reason: Yup.string().required('reasonErr'),
})
